import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker   } from 'antd';


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';
import edit from '../../assets/images/icon/edit.png';

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			school_list: [],
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'] });
		
		}
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			let staff_id = this.props.match.params.id;
			var app = {user_id : user_id,staff_id:staff_id}
			getData('erp/staff_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
						});
					}else{
						this.setState({
							school_list: [],
							total_school: 0,
						});
					}
				}
			});
	}
  }
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

	render()

	{
	
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 
		 	 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">View Staff Profile</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
					<ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   <li class="breadcrumb-item"><a href="/staff-profiles/index">Staff Profile</a>
                           </li>
                           <li class="breadcrumb-item active">View Staff Profile
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
		 
           
			
			
            {this.state.school_list.map((list) => (
            
			<div class="col s12 m12 ex-padd">
            <div class="container view-Profile view-Profile-mobile">
			   <div class="col s12 m12 mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food ">
					<div class="children mb-20 iq-card2 bg-color-1">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="Abdul Profile" classname="as" key="1">
						<div class="bb d-flex">
						  <div class="col m2 center children-add">
							
											{(() => {
																if (list.profile_pic != '') {
																	return (
																		<img src={list.profile_pic} class="profile-img profile-img-mobile" /> 
																	)
																}else{
																	return (
																		<img src={person} class="profile-img" /> 
																	)
																}
															})()}	
							
							</div>
						  <div class="col m10 s12 no-padd">
								<div class="col m6 s12 mb-10">
									<label>First Name</label>
									<input type="text" value={list.first_name} disabled />
								</div>	
								<div class="col m6 s12 mb-10">
									<label>Last Name</label>
									<input type="text" value={list.last_name} disabled />
								</div>	
								<div class="col m4 s12 mb-10">
									<label>Mobile No.</label>
									<input type="text" value={list.mobile} disabled />
								</div>	
								<div class="col m4 s12 mb-10">
									<label>Email</label>
									<input type="text" value={list.email} disabled />
								</div>
								<div class="col m4 s12 mb-10">
									<label>Gender</label>
									<input type="text" value={list.gender} disabled />
								</div>	
						  </div>
						</div>  
						<div class="col m12 s12 mt-20 mb-10">
							<label>Residental Addresss</label>
							<input type="text" value={list.address} disabled />
						</div>
						<div class="col m4 s12 mb-10">
									<label>Birthday</label>
									<input type="text" value={list.birthday} disabled />
								</div>	
								<div class="col m4 s12 mb-10">
									<label>Blood Group</label>
									<input type="text" value={list.blood_group} disabled />
								</div>
								<div class="col m4 s12 mb-10">
									<label>Date of Joining</label>
									<input type="text" value={list.joining_date} disabled />
								</div>	
						</Panel>
					  </Collapse>
					</div> 
					
					<div class="children bg-blue communication iq-card2 bg-color-6 staff-ch view">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="Programs"  key="1">
							<Button className="snd-btn" >Kindergarden</Button>
						</Panel>
					  </Collapse>
					</div>

					<div class="children bg-blue permision iq-card2 bg-color-1 staff-ch view">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="Permisiom"  key="1">
							{list.permision.map(admin =>
							<div class="col m4"><img src={correct} />{admin}</div>
							)}
							
							
						</Panel>
					  </Collapse>
					</div>					
					
					<div class="notice-left">
							<Link to={`${process.env.PUBLIC_URL}/staff-profiles/edit-profile/${list.id}`}><img src={edit} /></Link>
						</div>
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
			
			))}
			
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
